/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_COMPANY_HELP = {
  screenId: 'settings-company',
  label: 'Compañía',
  navPath: 'Configuración → Compañía',
  keywords: ['razón social', 'cuit', 'datos empresa', 'arca', 'factura electrónica'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Datos fiscales y de contacto de la empresa; vinculación con ARCA para facturación electrónica.',
  sidebarItems: [{
    id: 'company',
    screenId: 'settings-company',
    label: 'Datos de la compañía',
    description: 'CUIT, IVA, domicilios y opciones de factura electrónica.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Configurás los datos oficiales de tu empresa: CUIT, condición de IVA, domicilios y teléfonos. Se usan en comprobantes, liquidaciones y exportaciones AFIP.',
        },
        {
          title: 'Identificación fiscal',
          fields: [
            { label: 'CUIT', description: '11 dígitos. Al crear, el sistema consulta ARCA y completa la razón social.' },
            { label: 'Razón social', description: 'Viene de ARCA; solo lectura.' },
            { label: 'Nombre de fantasía', description: 'Nombre comercial opcional.' },
            { label: 'IIBB / Condición IVA / Provincia', description: 'Datos impositivos obligatorios.' },
            { label: 'Inicio de actividades', description: 'Fecha registrada en AFIP.' },
            { label: 'Factura electrónica producción', description: 'Activa el entorno real de AFIP (desmarcado = homologación).' },
            { label: 'Plantilla de factura', description: 'Diseño del PDF de comprobantes (clásica, elegante, moderna).' },
          ],
        },
        {
          title: 'Direcciones, teléfonos y correos',
          paragraphs: [
            'Podés cargar varias filas con descripción (ej. «Sucursal centro»). Botón + para agregar. Al menos una dirección suele ser necesaria para comprobantes.',
          ],
        },
        {
          title: 'Guardar',
          paragraphs: ['Tocá «Guardar». Si es la primera carga, crea la compañía; si ya existe, actualiza los datos.'],
        },
      ],
    },
  }],
}
